module.exports = "/packs/media/modules/shared/components/Cookies/sections/commerce-fff4ba5123724c3c1e3995a9609ec30a.svg";